import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { NextStepPayload, OrderingStepperState, StepperKeysEnum } from './types';

const initialState: OrderingStepperState = {
  step: StepperKeysEnum.MENU,
};

const orderingStepperSlice = createSlice({
  name: 'orderingStepper',
  initialState,
  reducers: {
    changeStep: (state, action: PayloadAction<NextStepPayload>) => ({
      ...state,
      step: action.payload.nextStep,
    }),
    resetStep: (state) => ({
      ...state,
      step: StepperKeysEnum.MENU,
    }),
  },
});

export default orderingStepperSlice;
